<template>
    <modal class="patchStockModel" :isShow="isShow"  @keyup.esc="hide">
        <div class="header">自动补齐库存设置</div>
        <div class="modal-body">
            <div class="tit-box">
                <el-switch v-model="Autostate" :inline-prompt="true" active-text="启用菜品库存<安全库存时,自动补足到目标库存数" inactive-text=""></el-switch>
                <p class="note">注: 触发条件是 菜品安全库存大于0,且目标库存大于安全库存</p>
            </div>
            <div class="info-box">
                <div class="title">1.下单触发补齐库存时间区间</div>
                <div class="table-box">
                    <el-table class="el-table--scrollable-y" style="width: 100%;"  v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                        :data="tableList"
                        highlight-current-row
                        ref="tableEl">
                        <el-table-column fixed type="index" label="序号" width="50" align="center"/>
                        <el-table-column fixed label="操作" width="70" align="center">
                            <template #default="scope">
                                <div class="operation">
                                    <b class="iconfont icon-jia" @click="add(tableList,scope.$index)"></b>
                                    <b class="iconfont icon-jian" @click="del(tableList,scope.$index)"></b>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="每日生效时间" width="100" align="center">
                            <template #default="scope">
                                <el-time-picker v-model="scope.row.BTime" placeholder="请输入" format="HH:mm" :clearable="false"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="每日截止时间" width="100" align="center">
                            <template #default="scope">
                                <el-time-picker v-model="scope.row.ETime" placeholder="请输入" format="HH:mm" :clearable="false"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="适用周几" min-width="400" align="center">
                            <template #default="scope">
                                <el-checkbox-group v-model="scope.row.WEEK_DAY">
                                    <el-checkbox label="1">周一</el-checkbox>
                                    <el-checkbox label="2">周二</el-checkbox>
                                    <el-checkbox label="3">周三</el-checkbox>
                                    <el-checkbox label="4">周四</el-checkbox>
                                    <el-checkbox label="5">周五</el-checkbox>
                                    <el-checkbox label="6">周六</el-checkbox>
                                    <el-checkbox label="7">周日</el-checkbox>
                                </el-checkbox-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="info-box">
                <div class="title">2.每日时间点自动触发补齐库存设置</div>
                <div class="table-box">
                    <el-table class="el-table--scrollable-y" style="width: 100%;"  v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                        :data="table2List"
                        highlight-current-row
                        ref="tableEl2">
                        <el-table-column fixed type="index" label="序号" width="50" align="center"/>
                        <el-table-column fixed label="操作" width="70" align="center">
                            <template #default="scope">
                                <div class="operation">
                                    <b class="iconfont icon-jia" @click="add(table2List,scope.$index)"></b>
                                    <b class="iconfont icon-jian" @click="del(table2List,scope.$index)"></b>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="时间点" width="100" align="center">
                            <template #default="scope">
                                <el-time-picker v-model="scope.row.BTime" placeholder="请输入" format="HH:mm" :clearable="false"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="适用周几" min-width="400" align="center">
                            <template #default="scope">
                                <el-checkbox-group v-model="scope.row.WEEK_DAY">
                                    <el-checkbox label="1">周一</el-checkbox>
                                    <el-checkbox label="2">周二</el-checkbox>
                                    <el-checkbox label="3">周三</el-checkbox>
                                    <el-checkbox label="4">周四</el-checkbox>
                                    <el-checkbox label="5">周五</el-checkbox>
                                    <el-checkbox label="6">周六</el-checkbox>
                                    <el-checkbox label="7">周日</el-checkbox>
                                </el-checkbox-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="info-box">
                <div class="title">3.稽核门店备餐时间点<span style="color:red">注:00:00时间不保存</span></div>
                <div class="table-box">
                    <el-table class="el-table--scrollable-y" v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                        :data="table3List"
                        highlight-current-row
                        ref="tableEl3">
                        <el-table-column fixed type="index" label="序号" width="50" align="center"/>
                        <el-table-column fixed label="操作" width="70" align="center">
                            <template #default="scope">
                                <div class="operation">
                                    <b class="iconfont icon-jia" @click="add(table3List,scope.$index)"></b>
                                    <b class="iconfont icon-jian" @click="del(table3List,scope.$index)"></b>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="时间点" width="150" align="center">
                            <template #default="scope">
                                <el-time-picker v-model="scope.row.BTime" placeholder="请输入" format="HH:mm" :clearable="false"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn selected" @click="saveClick()">保存</button>
        </div>
    </modal>
</template>
<script>

export default {
    name:"patchStockModel",
    emits:["close"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
    },
    data(){
        return {
            //自动补足到目标库存数
            Autostate:false,
            tableList:[],
            table2List:[],
            table3List:[],
            varietySelect:""
        }
    },
    computed:{
        //全部选中状态
        isIndeterminate(){
            return this.tableList?.some(it=>it.Is_Print) && !this.isChecked;
        },
        //是否有勾选的
        isChecked(){
            if(this.tableList?.length>0){
                return !this.tableList?.some(it=>!it.Is_Print);
            }
            return false;
        }
    },
    watch:{
        isChecked(newVal){
            this.checkAll=newVal;
        }
    },
    mounted(){
        this.$cacheData.Printers().then((d)=>{
            this.printers=d;
        }).catch(e=>{
            console.log('打印机数据获取失败e:'+e)
        })
        
        this.add(this.tableList,0);
        this.add(this.table2List,0);
        this.add(this.table3List,0);
        this.loadData();

        
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        //获取菜品目标补齐库存设置
        loadData(){
            const loading =this.$loading({
                text: "获取数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            
            this.$httpAES.post("Bestech.CloudPos.GetFoodTargetStock", {}).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{
                    let info=d.ResponseBody||{};
                    console.log(info)
                    this.Autostate=info.AutoState===1;
                    this.tableList=info.foodTargetStockTimeSlot||[];//下单触发补齐库存时间区间
                    if(this.tableList.length==0){
                        this.tableList.push({
                            BTime:"00:00",
                            ETime:"00:00",
                            WEEK_DAY:""
                        })
                    }
                    this.tableList.forEach(it=>{
                        it.BTime=new Date('1970-01-01 '+it.BTime);
                        it.ETime=new Date('1970-01-01 '+it.ETime);
                        it.WEEK_DAY =(it.WEEK_DAY||"").split("/").filter(week=>week);
                    })
                    
                    this.table2List=info.foodTargetStockTimePoint||[];//每日时间点自动触发补齐库存设置
                    if(this.table2List.length==0){
                        this.table2List.push({
                            BTime:"00:00",
                            WEEK_DAY:""
                        })
                    }
                    this.table2List.forEach(it=>{
                        it.BTime=new Date('1970-01-01 '+it.BTime);
                        it.WEEK_DAY =(it.WEEK_DAY||"").split("/").filter(week=>week);
                    });

                    this.table3List=info.prefoodTargetStockTimePoint||[];//稽核门店备餐时间点
                    if(this.table3List.length==0){
                        this.table3List.push({
                            BTime:"00:00",
                            WEEK_DAY:""
                        })
                    }
                    this.table3List.forEach(it=>{
                        it.BTime=new Date('1970-01-01 '+it.BTime);
                    });
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("自动补齐库存设置数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
        /**保存 */
        async saveClick(){
            let slotList=[],pointList=[];
            this.tableList.forEach((it,index)=>{
                if((it.WEEK_DAY||[]).length>0){
                    slotList.push({
                        index:index,
                        BTime:it.BTime.Format("hh:mm"),
                        ETime:it.ETime.Format("hh:mm"),
                        WEEK_DAY:it.WEEK_DAY
                    })
                }
            });
            this.table2List.forEach((it,index)=>{
                if((it.WEEK_DAY||[]).length>0){
                    pointList.push({
                        index:index,
                        BTime:it.BTime.Format("hh:mm"),
                        ETime: '00:00',
                        WEEK_DAY:it.WEEK_DAY
                    })
                }
            });
            
            try {
                slotList.forEach((it)=>{
                    if(it.BTime>it.ETime){
                        this.$refs.tableEl.setCurrentRow(it);
                        throw "下单触发补齐库存 每日失效时间不能大于每日截止时间!";
                    }
                    // if(!it.WEEK_DAY || it.WEEK_DAY.length==0){
                    //     this.$refs.tableEl.setCurrentRow(it);
                    //     throw "下单触发补齐库存 请勾选适用周几!";
                    // }
                })
                slotList.forEach((it,index)=>{
                    slotList.slice(index+1).forEach((it2)=>{
                        //判断 周期 重叠时
                        if(it.WEEK_DAY.some(week=>it2.WEEK_DAY.indexOf(week)>=0)){
                            //判断 两个时间段是否重叠
                            if(it.BTime<=it2.BTime && it.ETime>=it2.BTime){//第二条数据 开始时间在 第一条数据时间范围内 
                                this.$refs.tableEl.setCurrentRow(it2);
                                throw `下单触发补齐库存 【${it.index+1}】与【${it2.index+1}】生效时间段重叠！`;
                            }else if(it.BTime<=it2.ETime && it.ETime>=it2.ETime){//第二条数据 结束时间在 第一条数据时间范围内 
                                this.$refs.tableEl.setCurrentRow(it2);
                                throw `下单触发补齐库存 【${it.index+1}】与【${it2.index+1}】数据生效时间段重叠！`;
                            }
                        }
                    })
                })

                
                pointList.forEach((it,index)=>{
                    pointList.slice(index+1).forEach((it2)=>{
                        //判断 周期 重叠时
                        if(it.WEEK_DAY.some(week=>it2.WEEK_DAY.indexOf(week)>=0)){
                            //判断 两个时间段是否重叠
                            if(it.BTime==it2.BTime){
                                this.$refs.tableEl2.setCurrentRow(it2);
                                throw `每日时间点自动触发补齐库存 【${it.index+1}】与【${it2.index+1}】时间点重叠！`;
                            }
                        }
                    })
                })
            } catch (error) {
                this.$message.warning(error);
                return;
            }
            let info={
                AutoState:this.Autostate?1:0,
                foodTargetStockTimeSlot:slotList.map(it=>{
                    return {
                        BTime:it.BTime,
                        ETime:it.ETime,
                        WEEK_DAY:it.WEEK_DAY?.join('/')
                    }
                }),
                foodTargetStockTimePoint:pointList.map(it=>{
                    return {
                        BTime:it.BTime,
                        ETime: '00:00',
                        WEEK_DAY:it.WEEK_DAY?.join('/')
                    }
                }),
                prefoodTargetStockTimePoint: this.table3List.map(it=>{
                    return {
                        BTime:it.BTime.Format("hh:mm"),
                        ETime: '00:00',
                    }
                }).filter(it=>it.BTime && it.BTime!="00:00")
            }
            

            let userInfo= this.$auth.getUserInfo();
            
            let param={
                Operate_User:userInfo?.Login_Name,
                User_ID:userInfo.User_ID,
                foodTargetStock:info
            }
            
            console.log(param)
             //设置菜品目标补齐库存
            const loading = this.$loading({
                text: "自动补齐库存设置保存中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.SetFoodTargetStock",param).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("保存成功");
                    this.hide();
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('保存失败：'+e.message);
                console.log('保存失败：',e);
            })
        },
        add(table,index){
            if(!table) return;
            table.splice(index+1,0,{BTime:new Date('1970-01-01 00:00'),ETime:new Date('1970-01-01 00:00'),WEEK_DAY:[]});
        },
        del(table,index){
            if(!table) return;
            table.splice(index,1);
            if(table.length==0){
                this.add(table,0)
            }
        }
    }
}
</script>
<style lang="scss">
@import './patchStockModel.scss'
</style>